import React from 'react'
import TextField from '@material-ui/core/TextField'
import EditorSection from './EditorSection'
import { editorType } from "./index"
import TitleEditor from './TitleEditor'

export const editorSections = {
    biological_hazard: "Potential Biological Hazard",
    bh_measure:"Measures to prevent, eliminate or reduce Biological Hazards",
    chemical_hazard: "Potential Chemical Hazard",
    ch_measure:"Measures to prevent, eliminate or reduce Chemical Hazards",
    physical_hazard: "Potential Physical Hazard",
    ph_measure:"Measures to prevent, eliminate or reduce Physical Hazards",
}

export default function({
    handleFormChange, 
    setActiveSection, 
    setUploadOpen,
    sopState,
    setSopState,
    attachments,
    children, 
}){

    const { 
        biological_hazard,
        bh_measure,
        chemical_hazard,
        ch_measure,
        physical_hazard,
        ph_measure,
    } = typeof attachments?.attachments !== 'undefined' ? { ... attachments?.attachments[`${editorType.hi.toLowerCase()}`] } : {}
    
    const handleOnClick = (section) => {
        setActiveSection(section)
        setUploadOpen(true)
    }
    
    const handleOnUpdate = (section, val) => {
        setSopState({...sopState, [section]: val})
    }

    return (
        <div>
            <h2>Hazards Inputs Editor</h2>
            <form noValidate autoComplete="off">
                <div>
                    <TextField id="title" label="Input / Ingredient" value={sopState.title} 
                    onChange={(e) => handleFormChange(e)} 
                    style={{width:'80%', marginBottom:20}}
                    />
                </div>
                <EditorSection 
                    sectionName={editorSections.biological_hazard}
                    onClick={ () => { handleOnClick('biological_hazard')}}
                    html={sopState?.biological_hazard}
                    onUpdate={ (val) => { handleOnUpdate('biological_hazard', val) }}
                    attachment={biological_hazard}
                />
                <EditorSection 
                    sectionName={editorSections.bh_measure}
                    onClick={ () => { handleOnClick('bh_measure')}}
                    html={sopState?.bh_measure}
                    onUpdate={ (val) => { handleOnUpdate('bh_measure', val) }}
                    attachment={bh_measure}
                />
                <EditorSection 
                    sectionName={editorSections.chemical_hazard}
                    onClick={ () => { handleOnClick('chemical_hazard')}}
                    html={sopState?.chemical_hazard}
                    onUpdate={ (val) => { handleOnUpdate('chemical_hazard', val) }}
                    attachment={chemical_hazard}
                />
                <EditorSection 
                    sectionName={editorSections.ch_measure}
                    onClick={ () => { handleOnClick('ch_measure')}}
                    html={sopState?.ch_measure}
                    onUpdate={ (val) => { handleOnUpdate('ch_measure', val) }}
                    attachment={ch_measure}
                />
                <EditorSection 
                    sectionName={editorSections.physical_hazard}
                    onClick={ () => { handleOnClick('physical_hazard')}}
                    html={sopState?.physical_hazard}
                    onUpdate={ (val) => { handleOnUpdate('physical_hazard', val) }}
                    attachment={physical_hazard}
                />
                <EditorSection 
                    sectionName={editorSections.ph_measure}
                    onClick={ () => { handleOnClick('ph_measure')}}
                    html={sopState?.ph_measure}
                    onUpdate={ (val) => { handleOnUpdate('ph_measure', val) }}
                    attachment={ph_measure}
                />
                {children}
            </form>
        </div>
    )
}